import { useTexts } from '../../../../../contexts/TextsContext';
import { resolveAssetUrl } from '../../../../../utils/utils';
import classes from './activityCard.module.scss';

const ActivityCard = ({ activity, isImageRight }) => {
    const texts = useTexts();

    return (
        <article className={`${classes.Card} ${isImageRight ? classes.ImageRight : classes.ImageLeft}`}>
            <div className={classes.Content}>
                <h3 className={classes.Title}>{texts[`activities.${activity.id}.title`]}</h3>
                <p className={classes.Description}>{texts[`activities.${activity.id}.description`]}</p>
            </div>
            <div className={classes.ImageWrapper}>
                <img
                    src={resolveAssetUrl(activity.imageSrc)}
                    alt={texts[`activities.${activity.id}.title`]}
                    className={classes.Image}
                />
            </div>
        </article>
    );
};

export default ActivityCard;
